import { useGT } from 'gt-react';
import { HighlighterIcon } from '@phosphor-icons/react';
import { Button } from 'src/components/ui/button';

/**
 * Show / hide toggle for the provenance bounding boxes. Matches the
 * ProvenancePdfViewer toolbar buttons (ghost icon, size-7). `pressed` reflects
 * "boxes visible" — the highlighter icon is filled when on, outlined when off.
 */
export function BoxVisibilityToggle({
  pressed,
  onToggle,
}: {
  pressed: boolean;
  onToggle: () => void;
}) {
  const t = useGT();
  return (
    <Button
      variant="ghost"
      size="icon"
      className="size-7"
      aria-pressed={pressed}
      title={pressed ? t('Hide bounding boxes') : t('Show bounding boxes')}
      onClick={onToggle}
    >
      <HighlighterIcon
        className="size-4"
        weight={pressed ? 'fill' : 'regular'}
      />
    </Button>
  );
}
